export class LegalInformation {

    name: string
    vat_number: string
    transaction_type: string
    address: string
    email: string
    phone_number: string
    postal_code: string
    rt: string
    rw: string


    constructor(d: any) {
        this.name = d.name
        this.vat_number = d.vat_number
        this.transaction_type = d.transaction_type
        this.address = d.address
        this.email = d.email
        this.phone_number = d.phone_number
        this.postal_code = d.postal_code
        this.rt = d.rt
        this.rw = d.rw
    }

    static build(d: any): LegalInformation {
        return new LegalInformation(d)
    }
}